import React from "react"
import { Box } from "@mui/joy";
import { useFormatter } from "src/mtska-frontend-app-component/utils";
import { useTranslation } from "react-i18next";
import { useDrawer } from "../Drawer";

const WidgetBudgetChecker = (props) => {
    const { formatCurrency } = useFormatter();
    const { t } = useTranslation();
    const { activate } = useDrawer();

    const startOfYear = new Date(`${props.year}-01-01`);
    const endOfYear = new Date(`${props.year}-12-31`);

    return (
        <Box className={"form-element form-budget-checker " + props.className} >
            <Box className="form-element-group">
                <Box className="form-element-control first">
                    <Box className="form-element-label">
                        {t('budget')} {props.budgetType}
                    </Box>
                    <Box className="form-element-value">
                        {formatCurrency(props.budget ?? 0)}
                    </Box>
                </Box>
                <Box className="form-element-control central" onClick={
                    () => activate('advertisingCost/list',
                        {
                            filters: {
                                items: [
                                    {
                                        "field": "registered_at",
                                        "operator": "between",
                                        "value": { from: startOfYear.toISOString().split('T')[0], to: endOfYear.toISOString().split('T')[0] }
                                    },
                                    {
                                        "field": "_related_area_name",
                                        "operator": "contains",
                                        "value": props.area
                                    },
                                    {
                                        "field": "_related_source_name",
                                        "operator": "contains",
                                        "value": props.source
                                    },
                                    {
                                        "field": "budgetType",
                                        "operator": "equals",
                                        "value": props.budgetType
                                    }
                                ]
                            },
                            columnsNeeded: [
                                "registered_at",
                                "_related_area_name",
                                "_related_source_name",
                                "value",
                                "budgetType",
                            ]
                        }
                    )
                }>
                    <Box className="form-element-label">
                        {t('eroded')} {props.year}
                    </Box>
                    <Box className={"form-element-value" + (props.budgetEroded > (props.budget ?? 0) ? ' negative' : props.budgetEroded < props.budget ? ' positive' : '')}>
                        {formatCurrency(props.budgetEroded ?? 0)}
                    </Box>
                </Box>
                <Box className="form-element-control last">
                    <Box className="form-element-label">
                        {t('remaining')} {props.year}
                    </Box>
                    <Box className={"form-element-value" + (props.budgetRemaining < 0 ? ' negative' : props.budgetRemaining > 0 ? ' positive' : '')}>
                        {formatCurrency(props.budgetRemaining ?? 0)}
                    </Box>
                </Box>
            </Box>
        </Box>
    );


};


export default WidgetBudgetChecker;
